export default {
  sections: {
    business_info: 'Informații despre afacere',
    bank_info: 'Informații bancare',
  },
  form: {
    company_name: {
      label: 'Numele restaurantului',
      placeholder: 'Numele restaurantului',
    },
    business_name: {
      label: 'Numele afacerii',
      placeholder: 'Numele afacerii',
    },
    owner_full_name: {
      label: 'Numele proprietarului',
      placeholder: 'Numele proprietarului',
    },
    business_address: {
      label: 'Adresa afacerii',
      placeholder: 'Adresa afacerii',
    },
    business_zip_code: {
      label: 'Codul poștal al afacerii',
      placeholder: 'Codul poștal al afacerii',
    },
    business_city: {
      label: 'Orașul afacerii',
      placeholder: 'Orașul afacerii',
    },
    business_country: {
      label: 'Țara afacerii',
      options: {
        DE: 'Germania',
        GB: 'Regatul Unit',
        US: 'Statele Unite',
      },
    },
    company_phone_number: {
      label: 'Număr de telefon restaurant',
      placeholder: 'Număr de telefon restaurant',
    },
    contact_person_full_name: {
      label: 'Numele persoanei de contact',
      placeholder: 'Numele persoanei de contact',
    },
    contact_person_phone_number: {
      label: 'Numărul de telefon al persoanei de contact',
      placeholder: 'Numărul de telefon al persoanei de contact',
    },
    contact_person_email: {
      label: 'E-mailul persoanei de contact',
      placeholder: 'E-mailul persoanei de contact',
    },
    business_bank_account_holder_name: {
      label: 'Titularul contului bancar',
      placeholder: 'Titularul contului bancar',
    },
    business_bank_account_number: {
      label: 'Numărul contului bancar',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Codul de rutare bancară',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'Cod fiscal afacere',
      placeholder: 'Cod fiscal afacere',
    },
  },
};
